import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ISportConfigModelAPI } from './sport.models';

@Injectable()
export class SportService {
    private _http = inject(HttpClient);

    public getSportConfig = (): Observable<ISportConfigModelAPI> => this._http.get<ISportConfigModelAPI>(`/sportconfig`);
}
